import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Checkbox, the 22px rounded square that means multi-select.
 *
 * CSS selector: `mobile/atoms.css` `.ds-checkbox` (+ `--checked` for the
 * span-based fallback, which this component does not need).
 *
 * Doctrine: accent marks selection state, so the checked fill is accent with a
 * dark glyph painted on top of it. The glyph itself comes from the shared
 * `--ds-check-glyph` token in `tokens.css`, drawn by the CSS as a background
 * image. Never redraw it inline, so a future glyph change lands in one place.
 *
 * The control stays exactly 22px. The 44px tap target belongs to the row
 * around it, so wrap this in `<OptionRow>` or an equivalent padded label.
 */
export const Checkbox = React.forwardRef(function Checkbox(
  { className, type = 'checkbox', ...rest },
  ref,
) {
  return <input ref={ref} type={type} className={cn('ds-checkbox', className)} {...rest} />;
});

export default Checkbox;
